import { createFileRoute } from '@tanstack/react-router'
import { RecordingSettingsPage } from '@/features/admin/recording-settings'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/recording/')({
  component: RecordingSettingsPage,
  beforeLoad: requireRole(['admin']),
})
